import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { ILabsListing } from 'app/models/core/home/labs-listing';
import { Observable } from 'rxjs';
import { IDemographics } from 'app/models/core/lab/demographics';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }),
  withCredentials: true
};

@Injectable({ providedIn: 'root' })

export class HomeService {
  private api: string = environment.privateApi + 'Home/';

  constructor(private http: HttpClient) {}

  getLabsListing(status: string, type:string, cert:string,search: string): Observable<ILabsListing[]>{
    
    return this.http.get<ILabsListing[]>(this.api + 'searchLabs/'  +
        status + '/' + type + '/' + cert + '/' + search 
        , { withCredentials: true });
  }
  
  getAddLab(): Observable<IDemographics> {
    return this.http.get<IDemographics>(this.api + 'addLab/'
        , { withCredentials: true });
  }

  saveAddLab(newLab:IDemographics): Observable<any> {
    return this.http.post(this.api + 'saveNewLab/', newLab
        , httpOptions);
  }
}
